import React from "react";

const ImageWidget = ({ widget }) => {
  const props = widget.props || {};
  const { url, alt, caption, rounded, height } = props;

  if (!url) return null;

  return (
    <figure className="m-0">
      <img
        src={url}
        alt={alt || widget.title || ""}
        className={`w-full object-cover ${rounded === false ? "" : "rounded-lg"}`}
        style={height ? { height, objectFit: "cover" } : undefined}
      />
      {caption && <figcaption className="mt-2 text-sm text-gray-500">{caption}</figcaption>}
    </figure>
  );
};

export default ImageWidget;
